import { useAuthContext } from "Data/auth/hooks"
import { SuspenseLoadingUI } from "Components/SuspenseLoadingUI/SuspenseLoadingUI"
import { LoadingResourceError } from "Components/LoadingResourceError/LoadingResourceError"
import { hasAnyPermissions, hasPermissions } from "Tools/user/shared"

type ILoadableProps = {
  children: JSX.Element
  user?: User | null
  permissions?: (string | string[])[]
  anyPermissions?: (string | string[])[]
}

export const Loadable = ({ permissions = [], anyPermissions = [], children }: ILoadableProps) => {
  const { user } = useAuthContext()
  const perms = permissions || []
  const anyPerms = anyPermissions || []
  const component = <SuspenseLoadingUI>{children}</SuspenseLoadingUI>
  const enforcePermissions = perms.length || anyPermissions.length
  if (enforcePermissions) return enforcePermissions && user
    && (anyPerms.length ? hasAnyPermissions(user!, anyPerms) : hasPermissions(user!, perms)) ? component : <LoadingResourceError retry={false} />
  else return component
}
